import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntFavoriteIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path
        d="M16 5.792L10.248 5.304L8 0L5.752 5.304L0 5.792L4.36 9.576L3.056 15.2L8 12.216L12.944 15.2L11.632 9.576L16 5.792Z"
        stroke={props.stroke || ""}
      />
    </SntIcon>
  );
};

export default SntFavoriteIcon;
